var _defs, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetrieveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51.459,
    viewBox: "0 0 50 51.459",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.056)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-6439.842-799.988l-5.293,5.294-7.654-7.653-7.651,7.652-5.293-5.292,12.944-12.946Z",
    transform: "translate(6465.733 812.933)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.485,
    height: 20.261,
    transform: "translate(9.202 10.727)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-6423.786-765.825h-50V-804.18h7.485v30.869h35.029V-804.18h7.485Z",
    transform: "translate(6473.786 817.284)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetrieveIcon);
export default __webpack_public_path__ + "static/media/retrieve_icon.0e2bb29f468b207b5a24b05bbbcf8416.svg";
export { ForwardRef as ReactComponent };